import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Ruta legacy: `/proyectos/:id/seguimiento` ahora vive como tab dentro
 * del detalle. Mantenemos el archivo solo para redirigir y no romper
 * enlaces externos (email, bookmarks, otros sistemas).
 */
export const Route = createFileRoute('/_private/proyectos/$id/seguimiento')({
  beforeLoad: ({ params }) => {
    // `redirect()` de TanStack Router devuelve un sentinel especial que la
    // libreria espera recibir por `throw`; no es un `Error` clasico.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/proyectos/$id',
      params,
      search: { tab: 'seguimiento' as const },
      replace: true,
    });
  },
});
